import { render, staticRenderFns } from "./packInvite.vue?vue&type=template&id=1c45c133&scoped=true"
import script from "./packInvite.vue?vue&type=script&lang=js"
export * from "./packInvite.vue?vue&type=script&lang=js"
import style0 from "./packInvite.vue?vue&type=style&index=0&id=1c45c133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45c133",
  null
  
)

export default component.exports